import { createReducer } from "deox";

import {
  accountBalanceError,
  accountBalanceLoading,
  accountBalanceSuccess,
  balanceError,
  balanceLoading,
  balanceSuccess,
  resetAccountBalance,
} from "./accountBalanceStateActions";
import { AccountStatement } from "../../../types/types";
import { purge } from "../purge/purgeStateActions";

export interface BalanceState {
  payload: AccountStatement | null;
  isError: boolean;
  isLoading: boolean;
}

export interface CurrentBalanceState {
  accountBalance: number | null;
  isError: boolean;
  isLoading: boolean;
}
export interface CombineBalanceState {
  balanceState: BalanceState;
  currentBalanceState: CurrentBalanceState;
}
export const initialState: CombineBalanceState = {
  balanceState: {
    payload: null,
    isError: false,
    isLoading: false,
  },
  currentBalanceState: {
    accountBalance: null,
    isError: false,
    isLoading: false,
  },
};

const balance = createReducer(initialState, (handleAction) => [
  handleAction(
    balanceSuccess,
    (state, action): CombineBalanceState => ({
      ...state,
      balanceState: {
        isLoading: false,
        isError: false,
        payload: action.payload,
      },
    })
  ),
  handleAction(
    balanceLoading,
    (state): CombineBalanceState => ({
      ...state,
      balanceState: {
        isLoading: true,
        isError: false,
        payload: state.balanceState.payload ?? null,
      },
    })
  ),
  handleAction(
    balanceError,
    (state): CombineBalanceState => ({
      ...state,
      balanceState: {
        isError: true,
        isLoading: false,
        payload: null,
      },
    })
  ),
  //current balance
  handleAction(
    accountBalanceSuccess,
    (state, action): CombineBalanceState => ({
      ...state,
      currentBalanceState: {
        isLoading: false,
        isError: false,
        accountBalance: action.payload,
      },
    })
  ),
  handleAction(
    accountBalanceLoading,
    (state): CombineBalanceState => ({
      ...state,
      currentBalanceState: {
        isLoading: true,
        isError: false,
        accountBalance: state.currentBalanceState.accountBalance ?? null,
      },
    })
  ),
  handleAction(
    accountBalanceError,
    (state): CombineBalanceState => ({
      ...state,
      currentBalanceState: {
        isError: true,
        isLoading: false,
        accountBalance: null,
      },
    })
  ),
  handleAction(
    resetAccountBalance,
    (state): CombineBalanceState => ({
      ...state,
      currentBalanceState: {
        accountBalance: null,
        isError: false,
        isLoading: false,
      },
    })
  ),
  handleAction(purge, () => initialState),
]);

export default balance;
